// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ChartJS } from "@components";
import type { AbsenceStatistics } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: AbsenceStatistics,
  isExporting: boolean,
}>;

export class AbsenceStatisticPerReason extends React.Component<Props> {
  get chartData() {
    const daysLostByReason = (this.props.data || {}).daysLostByReason || [];
    if (!daysLostByReason.length) {
      return [
        [this.props.t("NUMBER_OF_DAYS"), this.props.t("SHORT_TERM"), this.props.t("LONG_TERM")],
        ["", 0, 0],
      ];
    }

    const data = daysLostByReason.map(item => [
      item.description,
      item.value[0].value,
      item.value[1].value,
    ]);
    return [
      [this.props.t("NUMBER_OF_DAYS"), this.props.t("SHORT_TERM"), this.props.t("LONG_TERM")],
      ...data,
    ];
  }

  render() {
    return (
      <ChartJS
        type="bar"
        title={this.props.t("DAYS_LOST_PER_REASON")}
        data={{
          labels: this.chartData.slice(1).map(([label]) => label),
          datasets: [
            { label: this.props.t("SHORT_TERM"), data: this.chartData.slice(1).map(([, s]) => s) },
            { label: this.props.t("LONG_TERM"), data: this.chartData.slice(1).map(([, , l]) => l) },
          ],
        }}
        options={{ animation: false, wrapXAxisLabels: true }}
      />
    );
  }
}

export default localize()(AbsenceStatisticPerReason);
